import { Message } from '@surveycake/rc';
import { Wording } from '@surveycake/wording/survey';

export function triggerThirdPartyLoginFailedMessage(wording: Wording) {
  Message.error(wording.module.third_party_login.sign_in_failed, {
    duration: 2000
  });
}

export function activeDirectoryLoginFailedMessage(wording: Wording,errorMessage?: string) {
  let word;
  if(!errorMessage) {
    word = wording.module.login_ad.error.DEFAULT;
  } else if (errorMessage === 'AUTH_FAILED'){
    word = wording.module.login_ad.error.AUTH_FAILED;
  } else if (errorMessage === 'NOT_INIT') {
    word = wording.module.login_ad.error.NOT_INIT;
  } else if (errorMessage === 'RECAPTCHA_FAILED') {
    word = wording.module.login_ad.error.RECAPTCHA_FAILED;
  } else {
    word = wording.module.login_ad.error.DEFAULT;
  }

  Message.error(word, {
    duration: 2000
  });
}
